import React from 'react';
import { Paper, Typography, Box, Link } from '@mui/material';

const ContactPage = () => {
  return (
    <Box sx={{ backgroundColor: '#e3e3e3', minHeight: '600px', padding: '32px 0 64px' }}>
      <Box sx={{ width: '50%', margin: 'auto' }}>
        <CustomerServicePaper />
        <DistributionCentersPaper />
      </Box>
    </Box>
  );
};

const CustomerServicePaper = () => {
  const customerServiceData = [
    {
      name: 'Hayley Westhoff',
      email: 'h.westhoff@duvelusa.com',
      phone: '(816) 701-7232',
      division: 'Central, EAST(SOUTH) Divisions',
    },
    {
      name: 'Megan Stanley',
      email: 'm.stanley@duvelusa.com',
      phone: '(816) 701-7184',
      division: 'West , Midwest Divisions',
    },
  ];

  return (
    <Paper elevation={3} sx={{ marginTop: '16px', padding: '16px' }}>
      <Typography variant="h5" sx={{ borderBottom: 'solid 1px black', paddingBottom: '8px', marginBottom: '16px' }}>
        Customer Service
      </Typography>
      <Box sx={{ }}>
        {customerServiceData.map((contact, index) => (
          <Box key={index} sx={{ marginBottom: '16px' }}>
            <Typography>
              {contact.name} - <Link href={`mailto:${contact.email}`}>{contact.email}</Link> {contact.phone}
            </Typography>
            <Typography sx={{ marginLeft: '12px' }}>{contact.division}</Typography>
          </Box>
        ))}
      </Box>
    </Paper>
  );
};

const DistributionCentersPaper = () => {
  const distributionCenters = [
    {
      name: 'MO3Trails Warehouse',
      address: '8700 Elmwood Avenue #100 Kansas City, MO 64132',
      addressLink: 'https://www.google.com/maps/place/8700+Elmwood+Ave+%23100,+Kansas+City,+MO+64132/@38.9684913,-94.5387051,17z/data=!3m1!4b1!4m5!3m4!1s0x87c0e66bff092cd7:0x83259e59e12e608d!8m2!3d38.9684913!4d-94.5365164',
      email: 'appointments@duvelusa.com',
    },
    {
      name: 'Cooperstown Warehouse',
      address: '656 County Highway 33 Cooperstown, NY 13326',
      addressLink: 'https://www.google.com/maps/place/656+Co+Hwy+33,+Cooperstown,+NY+13326/@42.6265779,-74.9452927,288m/data=!3m1!1e3!4m5!3m4!1s0x89dc0813240ef3cb:0xf080298692503209!8m2!3d42.6268786!4d-74.9452273',
      email: 'warehouse@ommegang.com',
    },
  ];

  return (
    <Paper elevation={3} sx={{ marginTop: '16px', padding: '16px' }}>
      <Typography variant="h5" sx={{ borderBottom: 'solid 1px black', paddingBottom: '8px', marginBottom: '16px' }}>
        Distribution Centers
      </Typography>
      <Box sx={{ }}>
        {distributionCenters.map((center, index) => (
          <Box key={index} sx={{ marginBottom: '24px' }}>
            <Typography variant="h6" sx={{ fontFamily: "'Didact Gothic', sans-serif", textTransform: 'uppercase', fontSize: '18px', marginBottom: '8px' }}>
              {center.name}
            </Typography>
            <Typography>
              <Link href={center.addressLink} target="_blank" rel="noopener noreferrer">
                {center.address}
              </Link>
            </Typography>
            <Typography style={{marginTop: '16px'}}>
              Email: <Link href={`mailto:${center.email}`}>{center.email}</Link>
            </Typography>
          </Box>
        ))}
      </Box>
    </Paper>
  );
};

export default ContactPage;